<template>
  <div class="block">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageArr" :page-size="onePage" layout="total, sizes, prev, pager, next, jumper" :total="maxPage">
    </el-pagination>
  </div>
</template>
Í
<script>
import axios from 'axios' ;
import util from '../util/util' ;
export default {
  props: ['way'],
  data(){
    return {
      maxPage: 0,
      onePage: 0,
      currentPage: 0 ,
      pageArr : util.pageArr
    }
  },
  mounted: function(){
    this.getDataCount();
  },
  methods: {
    getDataCount(){
      let obj = {
        count: true 
      }
      this.way == '/users' ? obj.where = { type:'app'} : obj 
      axios.get(this.way,{
        params:obj
      }).then((response)=>{
        this.maxPage = response.data ;
        this.onePage = util.limit ;
        response.data>0? this.currentPage = 1 : this.currentPage= 0 ;
      })
    },
    handleSizeChange(val) {
      this.$emit('pageNum', val)
    },
    handleCurrentChange(val) {
      this.$emit('pageOne', val)
    },
  }
}
</script>

<style rel='stylesheet/scss' lang='scss' scoped>
  @import 'src/styles/mixin.scss';
  .block{
    @include floatBtn;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Page.vue?4be8ea3e